import { loadMongoData } from '@adornis/baseql/server/data-loader.js';
import { mailTemplateDefinitions } from '@adornis/mails/db/mail-template-definition.js';
import { BuddyMailTemplate, MailTemplateType } from '../entities/mail-templates.js';

// eslint-disable-next-line max-lines-per-function, complexity
export const ensureDefaultBuddyMailTemplates = async () => {
  for (const mailType of Object.values(MailTemplateType)) {
    if (mailType === MailTemplateType.FREE_FORM) continue;
    const definition = mailTemplateDefinitions[mailType];
    if (!definition) throw new Error('No definition found for type: ' + mailType);

    const existingMailTemplate = (await loadMongoData(BuddyMailTemplate, { emailType: mailType })).at(0);
    if (existingMailTemplate) {
      continue;
    }

    const subject = definition.defaultTemplate.subject;
    const content = definition.defaultTemplate.content;
    const name = definition.displayName;
    if (!subject || !content || !name) throw new Error('cant create default template for type: ' + mailType);

    await new BuddyMailTemplate({ emailType: mailType, name, subject, content }).create();
  }
};
